export default [

    {
        path: '',
        name: 'relatorios',
        redirect: { name: 'relatorios-home' },
    },

    {
        path: 'home',
        name: 'relatorios-home',
        component: () => import('@/aplicacao/modulos/relatorios/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO' },
    },

    {
        path: 'usuarios',
        name: 'relatorios-usuarios',
        component: () => import('@/aplicacao/modulos/relatorios/Usuarios'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_USUARIOS' },
    },

    {
        path: 'acessos-ti',
        name: 'relatorios-acessos-ti',
        component: () => import('@/aplicacao/modulos/relatorios/AcessosTI'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_ACESSOS_TI' },
    },

    {
        path: 'acessos',
        name: 'relatorios-acessos',
        component: () => import('@/aplicacao/modulos/relatorios/Acessos'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_ACESSOS' },
    },

    {
        path: 'clientes',
        name: 'relatorios-clientes',
        component: () => import('@/aplicacao/modulos/relatorios/Clientes'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_CLIENTES' },
    },

    {
        path: 'produtos',
        name: 'relatorios-produtos',
        component: () => import('@/aplicacao/modulos/relatorios/Produtos'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_PRODUTOS' },
    },

    {
        path: 'hierarquias',
        name: 'relatorios-hierarquias',
        component: () => import('@/aplicacao/modulos/relatorios/Hierarquias'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_HIERARQUIAS' },
    },

    {
        path: 'solicitacoes',
        name: 'relatorios-solicitacoes',
        component: () => import('@/aplicacao/modulos/relatorios/Solicitacoes'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_SOLICITACOES' },
    },

    {
        path: 'atividades',
        name: 'relatorios-atividades',
        component: () => import('@/aplicacao/modulos/relatorios/Atividades'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_ATIVIDADES' },
    },

    {
        path: 'clientes-solicitados',
        name: 'relatorios-clientes-solicitados',
        component: () => import('@/aplicacao/modulos/relatorios/ClientesSolicitados'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_CLIENTES_SOLICITADOS' },
    },

    {
        path: 'fechamento-mensal-de-solicitacoes',
        name: 'relatorios-fechamento-mensal-de-solicitacoes',
        component: () => import('@/aplicacao/modulos/relatorios/FechamentoMensalDeSolicitacoes'),
        meta: { autenticacao: true, permissao: 'ROLE_RELATORIO_FECHAMENTO_MENSAL_DE_SOLICITACOES' },
    },

]
